import React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './_components/columns';
import { jdsTableStyles } from '../../../components/jds/tableStyles';
import { JdsPagination } from '../../../components/jds/JdsPagination';
import '../../../components/jds/jds.css';
import { Actions } from './_components/actions';
import { useCouponsBootstrap } from './coupons.bootstrap.hook';

export function CouponsJussub() {
  const {
    data,
    loading,
    totalRows,
    perPage,
    filterText,
    activeOnly,
    resetPaginationToggle,
    initialParams,
    handlePageChange,
    handlePerRowsChange,
    handleAddCouponButton,
    handleFilterChange,
    handleClearFilter,
    handleActiveOnlyChange,
  } = useCouponsBootstrap();

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg">Cupom</h1>
      <p className="text-muted mb-10">Listagem de cupons do JusSub</p>

      <div className="jds-card jds-card--flush">
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <DataTable
            columns={columns}
            data={data}
            customStyles={jdsTableStyles}
            progressPending={loading}
            pagination
            perPage={perPage}
            paginationServer
            paginationDefaultPage={initialParams.page}
            paginationTotalRows={totalRows}
            paginationResetDefaultPage={resetPaginationToggle}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderAlign="left"
            subHeaderComponent={
              <Actions
                filterText={filterText}
                onFilter={handleFilterChange}
                onClear={handleClearFilter}
                activeOnly={activeOnly}
                onActiveOnlyChange={handleActiveOnlyChange}
                onAddClick={handleAddCouponButton}
              />
            }
            paginationComponent={JdsPagination}
            responsive={false}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    </div>
  );
}
